import { eolsApiRaw } from 'helpers/api.helper';

export const getSourceReturnLinkAppLink = (linkId: string, returnBody: string) => eolsApiRaw.post(`/api/app-link/return/${linkId}`, { data: returnBody });

export const getlinkHashSession = (linkHash: string, options) => eolsApiRaw.get(`/api/app-link/hash-link/${linkHash}`, options);
